import { useEffect, useState } from "react";
import { Nav, Navbar, NavItem, Button } from "react-bootstrap";
import { common } from "../../js/common";
import { DoorOpen } from "react-bootstrap-icons";


// TODO: Make "Login" item be "Account" when a session is confirmed.

interface UserData {
  userName: string;
  id: number;
  role: string;
}

// TODO: Move logout button into its own element file
const logOut = async () => {
  console.info("Logging out");
  // TODO: Perform a request to the backend to log out
  // TODO: Add a visual status notice of the log out process. Snackbar? New "please wait" notice?
  try {
    const response = await common.fetchRestAPI("sessions", "DELETE");
    if (!response.ok) {
      let msg = `HTTP error! status: ${response.status}`;
      try {
        const errorData = await response.json();
        if (errorData?.error) {
          msg = errorData.error;
        }
      } catch {
        /* response wasn't JSON */
      }
      throw new Error(msg);
    }
  } catch (error) {
    // silently catch error
    console.error("Encountered an error performing logout request: ", error);
  }

  //Redirect to homepage (potentially could refresh page in the future here)
  window.location.href = "/";
};

const AppNavBar = () => {
  const [userData, setUserData] = useState<UserData | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  // This leads to the possibility of having "Login"
  // either not be replaced after a while if the API times out/takes too long.
  // May want to look into better way to handle it.
  useEffect(() => {
    async function fetchHeader(): Promise<void> {
      // Set header
      try {
        // perform session-get request
        const response = await common.fetchRestAPI("sessions", "GET");

        // When we don't have credentials, just show the Login text.
        if (response.status === 401) {
          console.info("fetchHeader: Response returned 401, no session.");
          setLoading(false);
          return;
        }

        // Handle bad responses
        if (!response.ok) {
          let msg = `HTTP error! status: ${response.status}`;
          try {
            const errorData = await response.json();
            if (errorData?.error) {
              msg = errorData.error;
            }
          } catch {
            /* Response wasn't json */
          }
          throw new Error(msg);
        }

        // From the response, add the username as the title for the '/account' nav
        const data: UserData = await response.json();
        setUserData(data);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        // If the server was down, we shouldn't bother the user with an error notice.
        // TODO: Use a snackbar error notice for login header errors. Allow user to attempt re-logging in.
      }
    }
    fetchHeader();
  }, []);

  return (
    <Navbar expand="lg" className="p-3">
      <Navbar.Brand href="/">Family Recipes</Navbar.Brand>
      <Navbar.Toggle></Navbar.Toggle>
      <Navbar.Collapse>
        <Nav>
          <NavItem>
            <Nav.Link href="/">Home</Nav.Link>
          </NavItem>
          <NavItem>
            <Nav.Link href="/submit">Submit</Nav.Link>
          </NavItem>
          {userData?.role === "admin" && (
            <NavItem>
              <Nav.Link href="/admin">Admin</Nav.Link>
            </NavItem>
          )}
        </Nav>
        <Nav className="ms-auto">
          <NavItem>
            {loading ? (
              <div className="d-flex justify-content-center align-items-center">
                <div
                  className="spinner-border text-primary spinner-border-sm"
                  role="status"
                >
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : userData ? (
              <div>
                <Nav.Link href="/account">{userData.userName}</Nav.Link>
              </div>
            ) : (
              <Nav.Link href="/login">Login</Nav.Link>
            )}
          </NavItem>
          {userData ? (
            <NavItem>
              <Button
                onClick={logOut}
                variant="warning"
                style={{ paddingTop: "3px", paddingBottom: "10px" }}
              >
                <DoorOpen></DoorOpen>
              </Button>
            </NavItem>
          ) : null}
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
};

export default AppNavBar;
